<h2 class="text-center">Choose Membership Type</h2>

<ng-container *ngIf="membershipOptions$ | async as membershipOptions;">
  <div *ngFor="let option of membershipOptions">
    <label>
      <input
        type="radio"
        name="option.MembershipOptionId"
        class="card-input-element d-none"
        [(ngModel)]="selectedOptionItem"
        [checked]="selectedOptionItem == option"
        [value]="option"
      />
      <div class="card card-body bg-light d-flex flex-row justify-content-between align-items-center rounded-sm">
        {{option.DisplayName}}
        <span>{{option.Description}}</span>
      </div>
    </label>
  </div>
</ng-container>
<fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
